// extracted by mini-css-extract-plugin
module.exports = {"root":"Panel_root__3IvO6","multiple":"Panel_multiple__2WgTm"};